import { useMutation, useQuery } from "@tanstack/react-query";
import { createNickNameWeb, getNickNameWeb } from "../../../service/nickName";
import { deleteFeedCommentWeb } from "../../../service/feed";

const useGetNickName = (enabled?: boolean) => {
    const query = useQuery({
        queryKey: ['nickName'],
        queryFn: () => getNickNameWeb(),
        select: (res) => res.data,
        enabled: !!enabled
    });

    return query
}

const useCreateNickNameWeb = () => {
    const mutation = useMutation({
        mutationFn: createNickNameWeb,
    });
    return mutation;
}

const useDeleteFeedCommentWeb = () => {
    const mutation = useMutation({
        mutationFn: deleteFeedCommentWeb,
    });
    return mutation;

}
export { useGetNickName, useCreateNickNameWeb, useDeleteFeedCommentWeb }